/**
 * The "Pro" tag — an accent pill shown beside "Caliu" and on Pro-locked
 * affordances (theme / font specimens). Brand token, never translated.
 * Mirrors the Swift `ProTag`. Caller can override size via `className`.
 */
/**
 * `size` (px) scales the pill like Swift `ProTag(size:)`: padding 0.18 × 0.6 of
 * it around a natural line height, as SwiftUI's Text has.
 */
export function ProTag({ className = "", size }: { className?: string; size?: number }) {
  return (
    <span
      style={size ? { fontSize: size, lineHeight: 1.25, padding: `${size * 0.18}px ${size * 0.6}px` } : undefined}
      className={`inline-flex items-center rounded-full bg-accent px-2 py-1 font-chrome text-[11px] font-bold leading-none text-on-accent ${className}`}
    >
      Pro
    </span>
  );
}
